import styled, { css } from 'styled-components';

interface ContainerProps {
  color: string;
  background: string;
  size: string;
  variant: string;
  height: string;
  nowrap: boolean;
  rounded: boolean;
  active: boolean;
  focus?: boolean;
}

export const Container = styled.button<ContainerProps>`
  background: ${props => props.background};
  border: 2px solid ${props => props.theme.colors.secondary.main};
  border-radius: ${props => (props.rounded ? '20px' : '8px')};
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: 14px;

  cursor: pointer;
  transition: opacity 0.2s;

  padding: ${props => (props.size === 'icon' ? '0px' : '12px 24px')};

  height: ${props => props.height};
  width: ${props => {
    switch (props.size) {
      case 'icon':
        return '24px';
      case 'mini':
        return '70px';
      case 'small':
        return '130px';
      case 'medium':
        return '200px';
      case 'large':
        return '240px';
      case 'bigger':
        return '300px';
      case 'even-bigger':
        return '340px';
      case 'fit-content':
        return 'fit-content';
      default:
        return '100%';
    }
  }};

  &:hover:not(:disabled) {
    filter: brightness(0.9);
    color: ${props => props.theme.colors.background.hover};
    transition: all 0.3s;
    svg {
      stroke: #fff;
    }
  }

  &:active {
    background-color: ${props => props.background};
    border: ${props => `2px solid ${props.theme.colors.secondary.dark}`};
    color: ${props => props.color};
    transition: 0.2s;
  }

  ${props =>
    props.nowrap === true &&
    css`
      overflow: hidden;
      white-space: nowrap;
      text-overflow: inherit;
    `}

  ${props =>
    props.variant === 'primary' &&
    css`
      border: none;
    `}

  ${props =>
    props.variant === 'secundary' &&
    props.active === false &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.primary.main};
      background-color: transparent;
      color: ${({ theme }) => theme.colors.primary.main};

      &:focus {
        /* border: none;
        border-style: double; */
      }

      &:disabled {
        background-color: transparent;

        :hover {
          color: #fff;
          background-color: ${props.color};
        }
      }
      &:hover {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.primary.main};
      }
    `}

  ${props =>
    props.variant === 'secundary' &&
    props.active === true &&
    css`
      color: #fff;
      background-color: ${props.color};

      &:focus {
        border: 2p solid ${props.color};

        :hover {
          color: #fff;
          background-color: ${props.color};
        }
      }

      &:hover {
        color: #fff;
        background-color: ${props.color};
      }
    `}

  ${props =>
    props.variant === 'disabled' &&
    css`
      color: gray;
      background-color: #d3d3d3;
      border-color: #d3d3d3;
      border: 2px solid ${props.theme.colors.primary.light};
      color: ${props.theme.colors.primary.light};
      cursor: not-allowed;
    `}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5 !important;
    color: gray;
    background-color: #d3d3d3;
    border-color: #d3d3d3;
  }
`;

interface LogoProps {
  noMargin?: boolean;
}

export const Icon = styled.div<LogoProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${props => !props.noMargin && '10px'};
  color: '#FFF';
`;
